import React from 'react';

const ITServicesHireInterns = () => {
  return (
    <main style={{ padding: 40, minHeight: '60vh' }}>
      <h1>AILYT IT Services — Hire Interns</h1>
      <p>Engagement model and how to hire talented interns from AILYT IT Services.</p>
    </main>
  );
};

export default ITServicesHireInterns;
